module.exports = __webpack_public_path__ + "static/media/ih.2a9860d8.png";